module.exports = __webpack_public_path__ + "img/phone_no.9d8acd36.png";